var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AttachmentSection',{attrs:{"files":_vm.files}}),_c('v-card',{attrs:{"rounded":""}},[_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.text)}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }